import { withAuth } from 'features/auth/withAuth';
import MyAccount from 'layouts/MyAccount';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

function TeamMembersPage() {
  const router = useRouter();

  useEffect(() => {
    router.push('/my-account/team');
  }, []);

  return <MyAccount></MyAccount>;
}

export default withAuth(TeamMembersPage);
